module.exports = __webpack_public_path__ + "static/media/298272.484e6c78.png";